<template>
  <v-container>
    <div>
      <v-row justify="start">
        <v-col cols="12" sm="3">
          <vc-date-picker mode="range" v-model="dateRange" :popover="{label: 'Hover', visibility: 'hover'}">
          </vc-date-picker>
        </v-col>

        <v-col cols="12" sm="2" justify="end">
          <v-btn color="primary" dark @click="getData">{{ $t('common.search') }}</v-btn>
        </v-col>

        <v-col cols="12" sm="7">
          <div class="d-flex flex-row-reverse">
            <v-btn color="primary" dark @click="getData">{{ $t('common.refresh') }}</v-btn>
          </div>
        </v-col>
      </v-row>
    </div>

    <v-data-table :headers="headers" :items="desserts" :search="search" sort-by="date" class="elevation-1"
                  hide-default-footer :page.sync="page" :items-per-page="itemsPerPage" :loading="loading"
                  calculate-widths @page-count="pageCount = $event" :item-class="this.$statusDesigner">
      <template v-slot:top>
        <v-toolbar flat color="white">
          <span>
            Tổng số: <span class="summaryFont"> {{ totalDesignRequest }} </span>
          </span>

          <span class="mx-5">
                Điểm: <span class="scoreFont"> {{ numberOfDesignRequestHaveReward }} </span> 
              </span>

          <span>
                Chưa xử lý: <span class="unfinishFont"> {{ numberOfTodoDesignRequest }} </span> 
              </span>


          <span class="mx-5">
                Đã SX: <span class="finishFont"> {{ numberOfCompleteDesignRequest }} </span> 
              </span>

        </v-toolbar>

        <v-toolbar flat color="white" class="pt-5">
          <v-row justify="start">
            <v-col cols="12" sm="1">
              <v-autocomplete v-model="itemsPerPage" :items="numberPage" outlined :dense="true"></v-autocomplete>
            </v-col>
            <v-spacer></v-spacer>

            <v-col cols="12" sm="2">
              <v-autocomplete v-model="selectReadStatus" :items="readStatus" item-text="title" outlined :dense="true" return-object></v-autocomplete>
            </v-col>

            <v-col cols="12" sm="3" v-if="!isAdmin && userCategory > 1">
              <v-autocomplete v-model="selectJobFilter" :items="jobFilters" item-text="title" dense return-object
                              outlined></v-autocomplete>
            </v-col>

            <v-col cols="12" sm="6">
              <v-text-field v-model="search" append-icon="search" v-bind:label="$t('common.search')" single-line
                            hide-details outlined :dense="true"></v-text-field>
            </v-col>
          </v-row>
        </v-toolbar>
      </template>

      <template v-slot:[`item.designer`]="{ item }">
        <div class="contentAddress">
          <v-tooltip slot="append-outer" bottom max-width="300px" color="primary">
            <template v-slot:activator="{ on }">
              <v-avatar v-on="on" size="30" class="mr-1">
                <img v-if="item.designer.avatar" :src="baseImage + item.designer.avatar"/>
                <img v-else src='@/assets/avatar_default.png'/>
              </v-avatar>
            </template>
            <span>
                  {{ item.designer.fullname }}
                </span>
          </v-tooltip>
          <span>
                {{ item.designer.nickname }}
              </span>
        </div>
      </template>

      <template v-slot:[`item.sale`]="{ item }">
        <div class="contentAddress" @click="showReportDialog(item)">
          <v-tooltip slot="append-outer" bottom max-width="300px" color="primary">
            <template v-slot:activator="{ on }">
              <v-avatar v-on="on" size="30" class="mr-1">
                <img v-if="item.sale.avatar" :src="baseImage + item.sale.avatar"/>
                <img v-else src='@/assets/avatar_default.png'/>
              </v-avatar>
            </template>
            <span>
                  {{ item.sale.fullname }}
                </span>
          </v-tooltip>
          <span>
                {{ item.sale.nickname }}
              </span>
        </div>
      </template>

      <template v-slot:[`item.createdAt`]="{ item }">
        <span>{{ item.createdAt | formateDate }}</span>
      </template>

      <template v-slot:[`item.detail`]="{ item }">
        <v-tooltip slot="append-outer" bottom max-width="300px" color="primary">
          <template v-slot:activator="{ on }">
            <v-icon v-on="on" small class="mr-2" @click="showDetail(item)">
              info
            </v-icon>
          </template>
          <span>Thông tin chi tiết</span>
        </v-tooltip>
      </template>

      <template v-slot:[`item.forward`]="{ item }">
        <v-btn color="primary" @click="sendToDesigner(item)" :disabled="item.status == 2">
          {{ item.status == 2 ? 'Đã chuyển SX' : $t('design_manager.forward_designer') }}
        </v-btn>
      </template>

      <template v-slot:[`item.requestTitle`]="{ item }">
              <span class="contentTitle">
                {{ item.requestTitle + (item.orderUnit ? (' - ' + item.orderUnit.name) : '') }}
              </span>
      </template>

      <template v-slot:[`item.customer.fullname`]="{ item }">
              <span class="contentName">
                {{ item.customer ? item.customer.fullname : 'Chưa có' }}
              </span>
      </template>

      <template v-slot:no-data>
        <!-- <v-btn color="primary" @click="initialize">Reset</v-btn> -->
      </template>
    </v-data-table>

    <div class="text-center pt-2">
      <v-pagination v-model="page" :length="pageCount"></v-pagination>
    </div>

    <v-dialog v-model="dialogSelectDesigner" max-width="60%">
      <v-card>
        <v-card-title>
          <span class="headline">Chọn designer</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <span class="font-weight-black pb-2"> {{ $t('create_design_request.chosen_group') }} </span>
            <v-row>
              <v-col cols="12" sm="4">
                <v-autocomplete v-model="selectTeam" :items="teams" item-text="name" return-object
                                outlined></v-autocomplete>
              </v-col>
            </v-row>

            <span class="font-weight-black pb-2"> Chọn Designer </span>

            <v-row>
              <v-col cols="12" sm="2" v-for="design in designers" :key="design._id">
                <v-row align="center" justify="center">
                  <v-col class="12" sm="12">
                    <v-row class="mb-2" align="center" justify="center">
                      <v-avatar size="90" @click="selectedDesigner = design.user">
                        <img :class="selectedDesigner._id == design.user._id ? 'avataraBorder' : ''"
                             v-if="design.user.avatar" :src="baseImage + design.user.avatar"/>
                        <img :class="selectedDesigner._id == design.user._id ? 'avataraBorder' : ''" v-else
                             src='@/assets/avatar_default.png'/>
                      </v-avatar>
                    </v-row>
                    <v-row align="center" justify="center">
                      <span class="font-weight-black"> {{ design.user.fullname }} </span>
                    </v-row>
                    <v-row align="center" justify="center">
                      <span> {{ design.numberOfTodoDesignRequest }} TK/3 ngày </span>
                    </v-row>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-container>

          <v-divider></v-divider>
          <v-toolbar flat>
            <v-btn color="primary" width="120px" @click="closeSelectDesigner">{{ $t('common.cancel') }}</v-btn>

            <v-spacer></v-spacer>

            <v-btn color="primary" @click="checkSelectDesigner" width="120px" class="mr-5">
              {{ $t('common.continue') }}
            </v-btn>
          </v-toolbar>
        </v-card-text>
      </v-card>
    </v-dialog>

    <report-dialog :dialog="reportDialog" @closeDialog="closeReport" :designRequest="editedItem"
                   :targetUser="selectdSale"></report-dialog>

    <design-request-dialog v-model="dialogDetail" :editedItem="editedItem" @closeDialog="closeDetail" @update="updateItem" v-if="editedItem">
    </design-request-dialog>

    <v-overlay :value="overlay" :z-index="0">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
  </v-container>
</template>

<script>
import i18n from '@/plugins/i18n';
import VueJwtDecode from 'vue-jwt-decode';
import moment from 'moment';
import ReportDialog from "@/components/ReportDialog";
import socketClient from '@/plugins/socketClient';
import DesignRequestDialog from "@/components/DesignRequestDialog";

export default {
  data: () => ({
    baseImage: process.env.VUE_APP_BASE_IMAGE,
    baseAttach: process.env.VUE_APP_BASE_ATTACH,

    isAdmin: localStorage.getItem('isAdmin') === 'true' ? true : false,
    userCategory: parseInt(localStorage.getItem('category')),
    userID: localStorage.getItem('user_id'),

    dateRange: {start: new Date(new Date().setDate(new Date().getDate() - 7)), end: new Date()},

    personalJobs: [],
    staffJobs: [],
    overlay: false,

    page: 1,
    pageCount: 0,
    itemsPerPage: 10,

    selectJobFilter: {},
    jobFilters: [
      {title: i18n.t('common.owner_job'), value: 0},
      {title: i18n.t('common.staff_job'), value: 1}
    ],

    selectReadStatus: {title: i18n.t('common.all'), value: -1},
    readStatus: [
      {title: i18n.t('common.unread'), value: 0},
      {title: i18n.t('common.read'), value: 1},
      {title: i18n.t('common.all'), value: -1}
    ],

    isSearching: false,
    loading: true,
    numberPage: [
      5, 10, 15, 20, 25
    ],

    search: '',
    dialog: false,
    reportDialog: false,
    dialogDetail: false,
    dialogSelectDesigner: false,
    rateDialog: false,

    selectedDesigner: {},
    selectedDesignerRequest: {},
    designers: [],
    selectTeam: {},
    selectdSale: {},

    selectUser: {},

    front_image: null,
    behind_image: null,
    arm_image: null,
    teams: [],

    front_printStyle: {},
    behind_printStyle: {},
    arm_printStyle: {},

    editedCustomerType: {},
    editedDefaultAddress: {},
    requestDetails: [],

    totalDesignRequest: 0,
    timeout_process: 24,
    totalManufacture: 0,
    totalUnmanufacture: 0,

    numberOfTodoDesignRequest: 0,
    numberOfDesignRequestHaveReward: 0,
    numberOfWaitingApprovalDesignRequest: 0,
    numberOfCompleteDesignRequest: 0,
    numberOfApprovalPendingDesignRequest: 0,

    headers: [],
    desserts: [],
    editedIndex: -1,
    editedItem: null,
    editedCustomer: {},
    defaultItem: {},
    stringRules: [
      v => !!v || i18n.t('validate.not_empty'),
      v => (v && v.length > 5) || i18n.t('validate.string_invalid')
    ]
  }),

  components: {
    DesignRequestDialog: DesignRequestDialog,
    ReportDialog: ReportDialog
  },

  watch: {
    // dialogDetail(val) {
    //   val || this.closeDetail()
    // },
    selectTeam(val) {
      this.getDesignByContext(val);
    },
    dialogSelectDesigner(val) {
      val || this.closeSelectDesigner()
    },
    rateDialog(val) {
      val || this.closeRate()
    },

    selectReadStatus() {
      this.filterData();
    },

    selectJobFilter() {
      if (this.selectJobFilter.value === 1) {
        this.headers = [
          {text: '#', align: 'left', sortable: false, value: 'index',},
          {text: i18n.t('design_manager.code'), sortable: false, value: 'code'},
          {text: i18n.t('design_manager.name'), sortable: false, value: 'requestTitle'},
          // { text: i18n.t('design_manager.customer'), sortable: false, value: 'customer.fullname'},
          {text: i18n.t('design_manager.date'), value: 'createdAt'},
          {text: i18n.t('design_manager.designer'), sortable: false, value: 'designer'},
          {text: '', sortable: false, value: 'designer.fullname', align: ' d-none'},

          {text: i18n.t('design_manager.sale'), sortable: false, value: 'sale'},
          {text: '', sortable: false, value: 'sale.fullname', align: ' d-none'},
          {text: i18n.t('design_manager.infor'), align: 'center', sortable: false, value: 'detail'},
          {text: '', value: 'forward', sortable: false}
        ]
      } else {
        this.headers = [
          {text: '#', align: 'left', sortable: false, value: 'index',},
          {text: i18n.t('design_manager.code'), sortable: false, value: 'code'},
          {text: i18n.t('design_manager.name'), sortable: false, value: 'requestTitle'},
          // { text: i18n.t('design_manager.customer'), sortable: false, value: 'customer.fullname'},
          {text: i18n.t('design_manager.date'), value: 'createdAt'},
          {text: i18n.t('design_manager.sale'), sortable: false, value: 'sale'},
          {text: '', sortable: false, value: 'sale.fullname', align: ' d-none'},
          {text: i18n.t('design_manager.infor'), align: 'center', sortable: false, value: 'detail'},
          {text: '', value: 'forward', sortable: false}
        ]
      }

      this.filterData();
    },
  },

  async created() {
    if (this.isAdmin) {
      this.headers = [
        {text: '#', align: 'left', sortable: false, value: 'index',},
        {text: i18n.t('design_manager.code'), sortable: false, value: 'code'},
        {text: i18n.t('design_manager.name'), sortable: false, value: 'requestTitle'},
        // { text: i18n.t('design_manager.customer'), sortable: false, value: 'customer.fullname'},
        {text: i18n.t('design_manager.date'), value: 'createdAt'},
        {text: i18n.t('design_manager.designer'), sortable: false, value: 'designer'},
        {text: '', sortable: false, value: 'designer.fullname', align: ' d-none'},

        {text: i18n.t('design_manager.sale'), sortable: false, value: 'sale'},
        {text: '', sortable: false, value: 'sale.fullname', align: ' d-none'},
        {text: i18n.t('design_manager.infor'), align: 'center', sortable: false, value: 'detail'},
        {text: '', value: 'forward', sortable: false}
      ]
    } else {
      this.selectJobFilter = this.jobFilters[0];
    }
    const self = this;

    self.getData();

    await Promise.all([
      this.getAllTeam()
    ]);
    this.isSearching = true;

    socketClient.getIO().on('UPDATE_DESIGN_REQUEST', () => {
      self.getData();
    });
  },

  methods: {
    initialize() {

    },

    closeRate(value) {
      this.rateDialog = value;
      this.close();
    },

    showReportDialog(item) {
      this.selectdSale = item.sale;
      this.editedItem = item;

      this.reportDialog = true;
    },

    closeReport(value) {
      this.reportDialog = value
    },

    showDetail(item) {
      this.editedIndex = this.desserts.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialogDetail = true;
    },

    closeDetail(value) {
      this.dialogDetail = value
      this.editedItem = null;
    },

    editItem(item) {
      this.editedIndex = this.desserts.indexOf(item)
      this.editedItem = Object.assign({}, item)
      this.dialog = true
    },

    async deleteItem(item) {
      const agree = confirm(i18n.t('common.confirm_delete'))

      if (agree) {
        const response = await this.$http.delete("/formStyle/" + item._id);
        if (response.data && response.data.success) {
          this.desserts.splice(item.index - 1, 1);
        }
      }
    },

    closeSelectDesigner() {
      this.dialogSelectDesigner = false
    },

    async getData() {
      const self = this;
      self.overlay = this.isSearching;
      try {
        // const response = await this.$http.get('/designRequest');
        const from = moment(String(self.dateRange.start)).format("DD/MM/YYYY");
        const to = moment(String(self.dateRange.end)).format("DD/MM/YYYY");

        // const response = await this.$http.get('/designRequest/by/me?' + "from=" + from + "&to=" + to);
        const response = await self.$http.get(process.env.VUE_APP_GET_DESIGN_REQUEST_CONTEXT_API + "?from=" + from + "&to=" + to);
        self.overlay = false;
        if (response.data && response.data.success) {
          self.personalJobs = [];
          self.staffJobs = [];
          const contextArr = response.data.data;
          contextArr.forEach((item, index) => item.index = index + 1);
          self.desserts = contextArr;
          this.desserts.forEach(item => {
            const designer = item.designer;
            if (designer && designer._id == self.userID) {
              self.personalJobs.push(item);
            } else {
              self.staffJobs.push(item);
            }
          })
          self.filterData();
          // self.totalDesignRequest = self.desserts.length;
          // self.totalManufacture = self.desserts.filter(item => item.status == 2).length;
          // self.totalUnmanufacture = self.desserts.filter(item => item.status == 1).length;

          // self.getSummaryDesignRequest();

          self.loading = false;
        }
      } catch (e) {
        console.log(e.stack);
      }
    },

    filterData() {
      if (this.selectJobFilter && this.selectJobFilter.value === 0) {
        this.desserts = [].concat(this.personalJobs);
      } else {
        this.desserts = [].concat(this.staffJobs);
      }

      if (this.selectReadStatus.value !== -1) {
        this.desserts = [].concat(this.desserts.filter(item => item.designerReadStatus == this.selectReadStatus.value));
      }

      this.totalDesignRequest = this.desserts.length;
      this.totalManufacture = this.desserts.filter(item => item.status == 2).length;
      this.totalUnmanufacture = this.desserts.filter(item => item.status == 1).length;

      this.getSummaryDesignRequest(this.selectJobFilter.value);
    },

    async checkSelectDesigner() {
      if (!this.selectedDesigner._id) {
        alert(i18n.t('design_item.warning_designer'));
      } else {
        try {
          const requestBody = {
            designer: this.selectedDesigner._id
          }

          const response = await this.$http.put('/designRequest/' + this.selectedDesignerRequest._id + '/designer', requestBody);

          if (response.data && response.data.success) {
            this.$fire({
              title: i18n.t('common.update_success'),
              text: "",
              type: "success"
            }).then(() => {
              this.closeSelectDesigner();
              this.getData();
            });
          }
        } catch (e) {
          console.log(e.stack);
        }
      }
    },

    async sendToDesigner(item) {
      const agree = confirm(i18n.t('common.confirm_send_to_designer'))
      if (agree) {
        this.selectedDesignerRequest = item;
        this.dialogSelectDesigner = true;
      }
    },

    async getDesignByContext(context) {
      const currentDate = moment(String(new Date())).format("DD/MM/YYYY");

      try {
        // const response =  await this.$http.get('/user/context/' + context._id);
        const response = await this.$http.get('/api/designRequest/contextStatsByUsersDateBack/' + context._id + "?dateBack=" + currentDate);
        if (response.data && response.data.success) {
          this.designers = response.data.data;

          const dataUser = VueJwtDecode.decode(localStorage.getItem('access_token'));
          const currentUser = this.designers.find(item => item._id == dataUser.data._id)
          if (currentUser) {
            this.designers.splice(currentUser);
          }
        }
      } catch (e) {
        console.log(e.stack);
      }
    },

    async getAllTeam() {
      try {
        const response = await this.$http.get('/context/parentType/2?level=2');
        if (response.data && response.data.success) {
          const contextArr = response.data.data;
          this.teams = contextArr;

          if (this.teams.length > 0) {
            this.selectTeam = this.teams[0];
          }

        }
      } catch (e) {
        console.log(e.stack);
      }
    },

    async getSummaryDesignRequest(jobFilterValue) {
      // /api/designRequest/userStats/:uid?from=DD/MM/YYYY&to=DD/MM/YYYY
      try {
        const userId = localStorage.getItem('user_id');
        const from = moment(String(this.dateRange.start)).format("DD/MM/YYYY");
        const to = moment(String(this.dateRange.end)).format("DD/MM/YYYY");
        var response = "";
        if (jobFilterValue === 0) {
          response = await this.$http.get('/api/designRequest/userStats/' + userId + "?from=" + from + "&to=" + to);
        } else {
          response = await this.$http.get('/api/designRequest/contextStats/my' + "?from=" + from + "&to=" + to);
        }

        // const response = await this.$http.get('/api/designRequest/contextStats/my' + "?from=" + from + "&to=" + to);

        if (response.data && response.data.success) {
          const data = response.data.data;
          this.numberOfTodoDesignRequest = data.numberOfTodoDesignRequest;
          this.numberOfDesignRequestHaveReward = data.numberOfDesignRequestHaveReward;
          this.numberOfWaitingApprovalDesignRequest = data.numberOfWaitingApprovalDesignRequest;
          this.numberOfCompleteDesignRequest = data.numberOfCompleteDesignRequest;
          this.numberOfApprovalPendingDesignRequest = data.numberOfApprovalPendingDesignRequest;
        }
      } catch (e) {
        console.log(e.stack);
      }
    },

    updateItem(value) {
      Object.assign(this.desserts[this.editedIndex], value);
    },

    itemRowBackground: function (item) {
      let readStatus = item.designerReadStatus === 0 ? 'unreadText' : 'readText';
      return readStatus;
    }
  },
}
</script>

<style>
.avataraBorder {
  border: 4px solid #F08942
}

.finishFont {
  font-size: 24px;
  font-style: normal;
  font-weight: normal;
  color: #0000FF;
}

.scoreFont {
  font-size: 24px;
  font-style: normal;
  font-weight: normal;
  color: #00FF00;
}

.unfinishFont {
  font-size: 24px;
  font-style: normal;
  font-weight: normal;
  color: #FF0000;
}
</style>